import { oz } from '@weft/utils';
import { PRICING_MODELS } from '../../../pricing/pricing-model-schema';
import { FixedPerUnitPricingConfigurationSchema } from './fixed-per-unit-pricing-configuration-schema';

export const FixedPerUnitPricingSchema = oz.object({
  pricingModel: oz.literal(PRICING_MODELS.FixedPerUnit),
  priceConfiguration: FixedPerUnitPricingConfigurationSchema,
}).openapi('FixedPerUnitPricing');

export type FixedPerUnitPricing = oz.infer<typeof FixedPerUnitPricingSchema>;